export default __webpack_public_path__ + "media/images/logo-9614df120a15ac1c2190b7ad6ddea491.png";